import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output, NgZone } from '@angular/core';

/**
 * @ngComponent ssg-expander
 * @whatItDoes This Component houses a caret expander and expanded content.
 * @howToUse
 *  <ssg-expander [open]='' [expandable]=''>
 *    <div expander-content>
 *      Your Content Here
 *    </div>
 *    <div expanded-content>
 *      Content to show when caret toggled
 *    </div>
 *  </ssg-expander>
 *  open can be used to trigger an "expand all" type operation by binding to an external boolean
 *  expandable defaults to true, but you can pass in a boolean to not show the expander caret if there's nothing to expand.
 * @example at-a-glance-collections-component
 */
@Component({
  selector: 'ssg-expander',
  templateUrl: './expander.component.html',
  styleUrls: ['./expander.component.less'],
  animations: [
    /* this animation doesn't work without introducing a bug
    trigger('slideIn', [
      state('*', style({'overflow-y': 'hidden'})),
      state('void', style({'overflow-y': 'hidden'})),
      transition('* => void', [
        style({height: '*'}),
        animate(250, style({height: 0}))
      ]),
      transition('void => *', [
        style({height: '0'}),
        animate(250, style({height: '*'}))
      ])
    ])
    */
  ]
})
export class ExpanderComponent implements OnInit {
  @Output() stateChanged = new EventEmitter<any>();
  _open: boolean;
  _expandable = true;

  constructor(private readonly zone: NgZone) {
  }

  ngOnInit() {
  }

  get open(): boolean {
    return this._open;
  }

  @Input() set open(value: boolean) {
    if (value === this._open) {
      return;
    }

    this.zone.run(() => {
      this._open = value;
      this.stateChanged.emit(value);
    });
  }

  get expandable(): boolean {
    return this._expandable;
  }

  @Input() set expandable(value: boolean) {
    if (value === this._expandable) {
      return;
    }

    this.zone.run(() => this._expandable = value);
  }

  toggle() {
    this.open = !this.open;
  }

}
